export default {
  data: [
    {
      id: 1,
      articleName: "Eje",
      isPrototype: false,
      grade: 1,
      figure: "eje",
      selected_figure: "cylinder",
      geometriaInicial:"Eje-00.dxf",
      geometriaFinal:"Eje-01.dxf",
      herramientaSuperior:"Eje-02.dxf",
      herramientaInferior:"Eje-03.dxf",
      hard_coat: 5,
      hardness_required: 700,
      date: "2020-02-10T13:52:38+01:00",
      calidadP: 5,
      EspMecanicas:{
        limiteElastico:550,
        resistenciaAtraccion:800,
        ElonRotura:13,
        RedArea:50,
        Dureza:240,
        EnergiaImp:{
          Valor:35,
          temp:20
        }
      }
    },
    {
      id: 2,
      articleName: "Rueda",
      isPrototype: false,
      grade: 4,
      figure: "rueda",
      selected_figure: "cylinder",
      geometriaInicial:"Rueda-00.dxf",
      geometriaFinal:"Rueda-01.dxf",
      herramientaSuperior:"Rueda-02.dxf",
      herramientaInferior:"Rueda-03.dxf",
      hard_coat: 10,
      hardness_required: 780,
      date: "2020-02-10T17:52:38+01:00",
      calidadP: 5,
      EspMecanicas:{
        limiteElastico:1700,
        resistenciaAtraccion:2300,
        ElonRotura:2,
        RedArea:"--",
        Dureza:61,
        EnergiaImp:{
          Valor:27,
          temp:20
        }
      }
    }
  ]
};
